import Button from "../Button"
import * as S from "./style"

export default function Head() {
    return (
    <S.Main>
        <S.Container>
            <img className="logo" src="images/logo.png" alt="" />
            {/* <p className="paragrafoPrimeiro">Se eu prometesse ensinar gatilhos mágicos para conquistar uma mulher eu estaria mentindo, o que eu vou te apresentar são técnicas comprovadas cientificamente para você</p> */}
            <h1>ative o instinto primitivo e descubra <span className="vermelho">como deixá-la obcecada por você!</span></h1>
            <p className="paragrafoFinal">Sem ficar correndo atrás dela, sem ser rejeitado e mesmo que seja inseguro ou tenha baixa confiança</p>
            <Button nome="quero descobrir os truques agora" url="#ancora"/>
        </S.Container>
     </S.Main>
     
    )
}